import { OrderedSet, Record } from 'immutable';
import { App } from '@gin-betting/core';

import {
    GET_TOP_TOURNAMENTS_REQUEST,
    GET_TOP_TOURNAMENTS_SUCCESS,
    GET_TOP_TOURNAMENTS_FAIL,
} from './constants';
import {
    Actions,
    PromoState,
    PromoStateShape,
    TopTournamentsStateShape,
} from './types';

export const TopTournamentsRecord = Record<TopTournamentsStateShape>(
    {
        tournaments: OrderedSet([]),
        fetchStatus: App.FetchStatus.INITIAL,
    },
    'TopTournamentsState'
);

export const PromoStateRecord = Record<PromoStateShape>(
    {
        topTournaments: new TopTournamentsRecord(),
    },
    'PromoState'
);

const initialState = new PromoStateRecord();

export default function reducer(
    state: PromoState = initialState,
    action: Actions
): PromoState {
    switch (action.type) {
        case GET_TOP_TOURNAMENTS_REQUEST: {
            const nextTopTournaments = state.topTournaments.set(
                'fetchStatus',
                App.FetchStatus.LOADING
            );

            return state.set('topTournaments', nextTopTournaments);
        }

        case GET_TOP_TOURNAMENTS_SUCCESS: {
            const {
                data: { topTournaments },
            } = action.payload;

            const tournaments = topTournaments.map(
                topTournament => topTournament.tournament.id
            );

            const newTopTournaments = state.topTournaments
                .set('fetchStatus', App.FetchStatus.LOADED)
                .set('tournaments', OrderedSet(tournaments));

            return state.set('topTournaments', newTopTournaments);
        }

        case GET_TOP_TOURNAMENTS_FAIL: {
            const nextTopTournaments = state.topTournaments.set(
                'fetchStatus',
                App.FetchStatus.FAILED
            );

            return state.set('topTournaments', nextTopTournaments);
        }

        default:
            return state;
    }
}
